"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCityPolygon = exports.getCityDetails = exports.getCities = void 0;
var tslib_1 = require("tslib");
var graphql_tag_1 = require("graphql-tag");
function getCities(_a) {
    var _b = _a.customWhere, customWhere = _b === void 0 ? {} : _b, citiesVersion = _a.citiesVersion;
    return {
        query: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      query($where: CityWhereInput!) {\n        cities(where: $where) {\n          id\n          name\n          keyName\n          lat\n          lng\n          radius\n          zoom\n        }\n      }\n    "], ["\n      query($where: CityWhereInput!) {\n        cities(where: $where) {\n          id\n          name\n          keyName\n          lat\n          lng\n          radius\n          zoom\n        }\n      }\n    "]))),
        variables: {
            where: tslib_1.__assign({ version: {
                    equals: citiesVersion,
                } }, customWhere),
        },
    };
}
exports.getCities = getCities;
function getCityDetails(_a) {
    var id = _a.id;
    return {
        query: (0, graphql_tag_1.default)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n      query($where: CityWhereInput!) {\n        cities(where: $where) {\n          id\n          name\n          population\n          governedByAr\n          areaInSqKms\n          intro\n          about\n          cityPolygon\n          zoom\n        }\n      }\n    "], ["\n      query($where: CityWhereInput!) {\n        cities(where: $where) {\n          id\n          name\n          population\n          governedByAr\n          areaInSqKms\n          intro\n          about\n          cityPolygon\n          zoom\n        }\n      }\n    "]))),
        variables: {
            where: {
                id: {
                    equals: id,
                },
            },
        },
    };
}
exports.getCityDetails = getCityDetails;
function getCityPolygon(_a) {
    var id = _a.id;
    var variables = {
        where: {
            id: {
                equals: id,
            },
        },
    };
    return {
        query: (0, graphql_tag_1.default)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n      query Cities($where: CityWhereInput) {\n        cities(where: $where) {\n          id\n          cityPolygon\n        }\n      }\n    "], ["\n      query Cities($where: CityWhereInput) {\n        cities(where: $where) {\n          id\n          cityPolygon\n        }\n      }\n    "]))),
        variables: variables,
    };
}
exports.getCityPolygon = getCityPolygon;
var templateObject_1, templateObject_2, templateObject_3;
